<template lang="pug">
.popup-single
  .wrapper
    .title {{title}}
    .btns
      .yes.btn(@click="$emit('yes')") 知道了
    
  
</template>
<script>
export default {
  name: 'PopupSingle',
  props: {
    title: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.popup-single
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  animation: fadeIn 0.5s $easeOutCubic both
  .wrapper
    width: pxToRem(600)
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    .title
      text-align: center
      width: 100%
      padding: pxToRem(40)
      font-size: pxToRem(36)
      color: black
      border-bottom: 1px rgba(102, 102, 102, 0.15) solid
    .btns
      width: 100%
      display: flex
      flex-direction: row
      align-items: center
      justify-content: center
      .btn
        width: 50%
        padding: pxToRem(25) pxToRem(40)
        font-size: pxToRem(36)
        text-align: center
        color: #1664FF

@keyframes fadeIn
  0%
    transform: scale(1.2)
    opacity: 0
  100%
    transform: scale(1)
    opacity: 1
</style>
